import { OperatorFunction, pipe } from 'rxjs';

import { AppState } from '../models/app-state.model';

import { filterNil } from './filter-nil';
import { select, SelectorConfig } from './select';

export function selectNotNil<T extends AppState, R>(mapFn: (state: T) => R, config?: SelectorConfig<R>): OperatorFunction<T, R> {
  return pipe(select(mapFn, config ? config : undefined), filterNil());
}
